import { Autocomplete, Button, TextField, Typography } from "@mui/material"
import { translate } from "app/language/service"
import React from "react"
import { FlexBox } from "ui/components/FlexBox"
import { ALL_GOOGLE_FONTS } from "ui/configuration/model"
import { IUIConfiguration } from "../model"
import { importFont } from "../tools/theme"
import { setTempUiConfigUndoRedo } from "../tools/undo-redo"

interface IUiConfigFontSelectorProps {
  uiConfig: IUIConfiguration
}

export const UiConfigFontSelector = React.memo(({ uiConfig }: IUiConfigFontSelectorProps) => {
  const [inputFont, setInputFont] = React.useState(uiConfig.font.googleFamily)
  return (
    <FlexBox vertical gap jc="start">
      <Typography color="textPrimary">{translate("admin.ui-configuration.font.help")}</Typography>
      <FlexBox fullWidth jc="start" gap sx={{ mb: "1rem" }}>
        <Autocomplete
          options={ALL_GOOGLE_FONTS}
          sx={{ "minWidth": "16rem", "& input": { fontSize: ".8rem", pr: "1.8rem !important" } }}
          size="small"
          id="admin-ui-config-font-select"
          value={inputFont}
          disableClearable
          onChange={(_event, newValue) => setInputFont(newValue || "")}
          renderInput={params => (
            <TextField {...params} required label={translate("admin.ui-configuration.font.select")} />
          )}
        />
        <Button
          variant="contained"
          disabled={uiConfig.font.googleFamily === inputFont || !inputFont}
          onClick={() => {
            const newConfig: IUIConfiguration = {
              ...uiConfig,
              font: {
                ...uiConfig.font,
                googleFamily: inputFont
              }
            }
            importFont(newConfig)
            setTempUiConfigUndoRedo(newConfig)
          }}>
          {translate("admin.ui-configuration.font.try")}
        </Button>
      </FlexBox>
    </FlexBox>
  )
})
